var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircleFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C20.1795 0 26 5.81986 26 13C26 20.1795 20.1795 26 13 26C5.82045 26 0 20.1795 0 13C2.57702e-07 5.81986 5.82045 2.57689e-07 13 0ZM18.0996 7.90039C17.6766 7.47738 16.9905 7.47749 16.5674 7.90039L13 11.4678L9.43262 7.90039L9.33105 7.81055C8.90607 7.4801 8.29091 7.50987 7.90039 7.90039C7.47738 8.3234 7.47749 9.00954 7.90039 9.43262L11.4678 13L7.90039 16.5674L7.81055 16.6689C7.4801 17.0939 7.50987 17.7091 7.90039 18.0996C8.3234 18.5226 9.00954 18.5225 9.43262 18.0996L13 14.5322L16.5674 18.0996L16.6689 18.1895C17.0939 18.5199 17.7091 18.4901 18.0996 18.0996C18.5226 17.6766 18.5225 16.9905 18.0996 16.5674L14.5322 13L18.0996 9.43262L18.1895 9.33105C18.5199 8.90607 18.4901 8.29091 18.0996 7.90039Z",
    fill: "#F20800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleFilled);
export default __webpack_public_path__ + "static/media/closeCircleFilled.59ee8283223a3ba33507dc465d0ebd77.svg";
export { ForwardRef as ReactComponent };